const PALETTE = {
  white: '#FFF',
  black: '#1A1A1A',
  trueBlack: '#000',
  transparent: 'transparent',
  greyscale5: '#F2F2F2',
  greyscale20: '#CCC',
  greyscale60: '#666',
  greyscale70: '#4D4D4D',
  greyscale80: '#333',
  greyscale85: '#262626',
  systemLightGrey: '#E8E8E8',
  systemMidGrey: '#D1D1D1',
  systemYellow: '#FFD440',
  systemLightYellow: '#FEF6DC',
  systemGreen: '#118847',
  systemLightGreen: '#E5F0E9',
  systemLimeGreen: '#5F8129',
  serviceOntarioGreen: '#006c40',
  systemRed: '#CD0000',
  systemRedLight: '#FCEFF0',
  systemMidRed: '#6B0000',
  systemDarkRed: '#280000',
  systemErrorRed: '#d81a21',
  systemBlue: '#0066CC',
  systemLightBlue: '#C2E0FF',
  systemLightestBlue: '#E0F0FF',
  systemMidBlue: '#00478F',
  systemDarkBlue: '#002142',
  systemFocusBlue: '#009ADB',
  systemInformationBlue: '#E2F0F4',
  systemInformation: '#1080A6',
  systemPurple: '#551A8B',
  systemTeal: 'rgba(207, 237, 237, 0.5)',
};

// Semantic colors
export default {
  background: PALETTE.white,
  baseLink: PALETTE.systemBlue,
  baseLinkHover: PALETTE.systemMidBlue,
  baseLinkActive: PALETTE.systemDarkBlue,
  baseLinkVisited: PALETTE.systemPurple,
  btnPrimaryBG: PALETTE.systemBlue,
  btnPrimaryHover: PALETTE.systemMidBlue,
  btnPrimaryActive: PALETTE.systemDarkBlue,
  btnSecondaryBG: PALETTE.white,
  btnSecondaryHover: PALETTE.systemLightestBlue,
  btnSecondaryActive: PALETTE.systemLightBlue,
  btnTertiaryBG: PALETTE.transparent,
  btnTertiaryHover: PALETTE.systemLightGrey,
  btnTertiaryActive: PALETTE.systemMidGrey,
  btnStepIndicator: PALETTE.systemBlue,
  btnStepIndicatorBG: PALETTE.transparent,
  systemBlack: PALETTE.black,
  systemLightGrey: PALETTE.greyscale5,
  serviceTagBG: PALETTE.systemTeal,
  hintTextColour: PALETTE.greyscale70,
  hintTextGrey: PALETTE.greyscale60,
  focusBlue: PALETTE.systemFocusBlue,
  calloutErrorBG: PALETTE.systemRedLight,
  calloutErrorBorder: PALETTE.systemRed,
  calloutErrorLink: PALETTE.systemRed,
  calloutErrorLinkHover: PALETTE.systemMidRed,
  calloutErrorLinkActive: PALETTE.systemDarkRed,
  calloutInformationBG: PALETTE.systemInformationBlue,
  calloutInformationBorder: PALETTE.systemInformation,
  calloutSuccessBG: PALETTE.systemLightGreen,
  calloutSuccessBorder: PALETTE.systemGreen,
  calloutWarningBG: PALETTE.systemLightYellow,
  calloutWarningBorder: PALETTE.systemYellow,
  footerBG: PALETTE.black,
  footerSectionTopBG: PALETTE.greyscale85,
  footerSectionTopBeforeBG: PALETTE.greyscale80,
  footerSocialMediaLinkHover: PALETTE.trueBlack,
  searchServicesText: PALETTE.trueBlack,
  hrBorder: PALETTE.greyscale20,
  subHeaderBG: PALETTE.serviceOntarioGreen,
  tagBG: PALETTE.systemLimeGreen,
  systemErrorRed: PALETTE.systemErrorRed,
  darkBtnHover: PALETTE.greyscale70,
  darkBtnActive: PALETTE.greyscale60,
  darkBtnBG: PALETTE.black,
  // Color palette should only be used when there's no appropriate "semantic" color
  palette: PALETTE,
};
